import React, {FC, useCallback, useMemo} from 'react';
import {ComboFiltersList} from 'plugins/modules/filter/components/ComboFiltersList';
import {ICatalogCombo} from 'modules/products/types';
import {isBrowserContext} from 'core/helpers';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {IFilterFacet, IFilterFacetEnum, IFilterFacetVariant} from 'plugins/modules/filter/types';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';

interface IProps {
    comboFiltersList: ICatalogCombo[];
}

export const ComboFiltersController: FC<IProps> = ({comboFiltersList}) => {
    const {pushRoute} = useFiltersRouterPush();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const handleApply = useCallback(
        (
            pathName: string,
            filter:
                | (IFilterFacet & {
                      value: IFilterFacetVariant['code'] | IFilterFacetEnum['code'];
                  })
                | null,
            isChecked: boolean,
        ) => {
            if (!filterInstance) {
                return;
            }
            if (!filter) {
                pushRoute(pathName, undefined, {
                    scroll: false,
                    shallow: true,
                });
            }
            if (filter) {
                const {pathName: filterPathName} = isChecked
                    ? filterInstance.userAddOneFilterValue(filter, filter.value)
                    : filterInstance.userRemoveOneFilterValue(filter, filter.value);

                pushRoute(filterPathName, undefined, {
                    scroll: false,
                    shallow: true,
                });
            }
        },
        [pushRoute, filterInstance],
    );

    return <ComboFiltersList comboFiltersList={comboFiltersList} onChange={handleApply} />;
};
